import { Extension } from "tiptap";
import OverQuotaPlugin from "./EditorPlugin";

export default class OverQuota extends Extension {
  get name() {
    return "over-quota";
  }

  keys() {}

  get plugins() {
    return [OverQuotaPlugin()];
  }

  commands() {}
}
